<template>
	<div v-html="linkHtml"></div>
</template>

<script>
    export default {
        name: "index",
        data () {
            return {
                linkHtml: undefined
            }
        },
        mounted () {
            console.log(this.$route.params,'路由传参');
            
            let html = this.$route.params.linkHtml;
            let index = html.lastIndexOf("<form");
            let nextIndex = html.lastIndexOf("</body>");
            this.linkHtml = html.substring(index,nextIndex);
            this.$nextTick(()=>{
                document.querySelector('#pay_form').submit();
            })
        }
    }
</script>

<style scoped>

</style>
